import React, { useState } from "react";
import Plugin from "./Plugin";
import { Country } from "./types";

interface ParsingConfiguratorProps {
  website: string;
  countries: Country[];
  vertical: string;
  user: string;
}

const Main: React.FC<ParsingConfiguratorProps> = ({
  website,
  countries,
  vertical,
  user,
}) => {
  const [country] = useState<Country>("default");

  return (
    <div>
      {/* {countries.length > 1 && CountrySelector({ countries, setCountry })} */}
      <Plugin
        website={website}
        country={country}
        vertical={vertical}
        countries={countries}
        user={user}
      />
    </div>
  );
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CountrySelector: React.FC<{
  countries: Country[];
  setCountry: (country: Country) => void;
}> = ({ countries, setCountry }) => {
  return (
    <select
      onChange={(e) => setCountry(e.target.value as Country)}
      defaultValue={"default"}
    >
      <option value="default" disabled>
        Select a country
      </option>
      {["default", ...countries].map((country) => (
        <option key={country} value={country}>
          {country}
        </option>
      ))}
    </select>
  );
};

export default Main;
